import {useEffect, useState} from "react";
import {APIGetHomeBanner} from "@/api";


const useHomeBanner = () =>{
  const [bannerList, setBannerList] = useState([]);

  const getBanner = async () =>{
    const res = await APIGetHomeBanner();
    if (res?.data?.result){
      setBannerList(res?.data?.result);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);


  return {
    getBanner,
    bannerList
  };
};

export default useHomeBanner;
